<!-- Modal achievement (Fuse version avec Tailwind) -->
@if (help() && canFire()) {
  <div 
    class="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4 animate-[fadeIn_0.3s_ease-in-out]"
    (click)="close()">
    <div 
      class="bg-white rounded-2xl max-w-[800px] w-full max-h-[90vh] overflow-y-auto shadow-[0_10px_40px_rgba(0,0,0,0.3)] animate-[slideUp_0.3s_ease-in-out]"
      (click)="$event.stopPropagation()">
      
      <div class="flex flex-col">
        
        <!-- Titre -->
        <div 
          class="font-bold text-3xl text-center px-4 pt-12 pb-4 text-black"
          [innerHTML]="title()"></div>
        
        <!-- Illustration -->
        @if (illustration()) {
          <div class="w-full bg-gradient-to-br from-sky-500 to-sky-600 p-8">
            <div class="mx-auto h-[35vh] min-h-[160px] max-h-[500px] w-full">
              <img 
                [src]="illustration()" 
                alt="Achievement illustration"
                class="h-full w-full object-contain" />
            </div>
          </div>
        }
        
        <!-- Contenu -->
        <div 
          class="px-8 py-8 max-w-[900px] mx-auto text-black leading-relaxed"
          [innerHTML]="content()"></div>
        
        <!-- Bouton fermer -->
        <div class="pb-8 px-8 text-center">
          <button 
            mat-raised-button 
            color="primary"
            (click)="close()">
            <span translate>feature.achievement-modal.closeButton</span>
          </button>
        </div>
        
      </div>
    </div>
  </div>
}
